export const buildUrl = (url, params = {}) => {
  const entries = Object.entries(params);

  entries.forEach(([key, val]) => {
    url = url.replace(`:${key}`, val);
  });

  return url;
};
